export enum VehicleSalesStatus {
    Current = 0,
    Complete = 1,
    Cancelled = 2,
}

